import api from '@/utils/api';

/**
 * Get all currencies
 * @param {string} query - get all currencies
 * @returns {Promise}
 */
const getCurrenciesApi = (query) => {
  const url = query ? `currency?${query}` : 'currency';
  return api.get(url);
};

export default getCurrenciesApi;
